import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Seguro } from '../models/seguro';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class SeguroService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(seguro: Seguro) {
    return this.http.post(globals.apiUrl + '/api/Seguro/Salvar', seguro);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Seguro/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Seguro/Buscar',
      { params: new HttpParams().set('id', id) });
  }


  consultarLista(idCupom?) {
    return this.http.get<Seguro[]>(globals.apiUrl + '/api/Seguro/Lista',
      {
        params: idCupom === null || idCupom === undefined || !idCupom ? null :
          new HttpParams().set('idCupom', idCupom)
      });
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    return this.http.get<any>(globals.apiUrl + '/api/Seguro/ListaPag',
      {
        params: parametros
      });
  }
}
